export const departmentOptions = [
  { value: "", label: "Select Department" },
  { value: "U-PT-001", label: "Product & Technology" },
  { value: "U-MG-002", label: "Marketing & Growth" },
  { value: "U-SD-003", label: "Sales & Business Dev" },
  { value: "U-CS-004", label: "Customer Success" },
  { value: "U-OP-005", label: "Operations" },
  { value: "U-DA-006", label: "Data & Analytics" },
  { value: "U-LC-007", label: "Legal & Compliance" },
  { value: "U-FN-008", label: "Finance" },
  { value: "U-HR-009", label: "Human Resources" },
];

export const gradeOptions = [
  { value: "", label: "Select Grade" },
  { value: "G10", label: "G10" },
  { value: "G9", label: "G9" },
  { value: "G8", label: "G8" },
  { value: "G7", label: "G7" },
  { value: "G6", label: "G6" },
  { value: "G5", label: "G5" },
  { value: "G4", label: "G4" },
  { value: "G3", label: "G3" },
  { value: "G2", label: "G2" },
  { value: "G1", label: "G1" },
];

export const roleOptions = [
  // Product & Technology
  { value: "U-PT-ROLE-001", label: "Executive (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-002", label: "Senior (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-003", label: "Mid-Senior (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-004", label: "Junior (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-005", label: "Entry (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-006", label: "Executive (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-007", label: "Senior (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-008", label: "Mid-Senior (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-009", label: "Junior (PT)", department: "U-PT-001" },
  { value: "U-PT-ROLE-010", label: "Entry (PT)", department: "U-PT-001" },

  // Marketing & Growth
  { value: "U-MG-ROLE-001", label: "Executive (MG)", department: "U-MG-002" },
  { value: "U-MG-ROLE-002", label: "Senior (MG)", department: "U-MG-002" },
  { value: "U-MG-ROLE-003", label: "Mid-Senior (MG)", department: "U-MG-002" },
  { value: "U-MG-ROLE-004", label: "Junior (MG)", department: "U-MG-002" },

  // Sales & Business Dev
  { value: "U-SB-ROLE-001", label: "Executive (SB)", department: "U-SD-003" },
  { value: "U-SB-ROLE-002", label: "Senior (SB)", department: "U-SD-003" },
  { value: "U-SB-ROLE-003", label: "Mid-Senior (SB)", department: "U-SD-003" },
  { value: "U-SB-ROLE-004", label: "Junior (SB)", department: "U-SD-003" },

  // Customer Success
  { value: "U-CS-ROLE-001", label: "Executive (CS)", department: "U-CS-004" },
  { value: "U-CS-ROLE-002", label: "Senior (CS)", department: "U-CS-004" },
  { value: "U-CS-ROLE-003", label: "Mid-Senior (CS)", department: "U-CS-004" },
  { value: "U-CS-ROLE-004", label: "Junior (CS)", department: "U-CS-004" },

  // Operations
  { value: "U-OP-ROLE-001", label: "Executive (OP)", department: "U-OP-005" },
  { value: "U-OP-ROLE-002", label: "Senior (OP)", department: "U-OP-005" },
  { value: "U-OP-ROLE-003", label: "Mid-Senior (OP)", department: "U-OP-005" },
  { value: "U-OP-ROLE-004", label: "Junior (OP)", department: "U-OP-005" },

  // Data & Analytics
  { value: "U-DA-ROLE-001", label: "Executive (DA)", department: "U-DA-006" },
  { value: "U-DA-ROLE-002", label: "Senior (DA)", department: "U-DA-006" },
  { value: "U-DA-ROLE-003", label: "Mid-Senior (DA)", department: "U-DA-006" },
  { value: "U-DA-ROLE-004", label: "Junior (HR)", department: "U-DA-006" },

  // Legal & Compliance
  { value: "U-LC-ROLE-001", label: "Executive (LC)", department: "U-LC-007" },
  { value: "U-LC-ROLE-002", label: "Senior (LC)", department: "U-LC-007" },
  { value: "U-LC-ROLE-003", label: "Mid-Senior (LC)", department: "U-LC-007" },
  { value: "U-LC-ROLE-004", label: "Junior (LC)", department: "U-LC-007" },

  // Finance
  { value: "U-FN-ROLE-001", label: "Executive (FN)", department: "U-FN-008" },
  { value: "U-FN-ROLE-002", label: "Senior (FN)", department: "U-FN-008" },
  { value: "U-FN-ROLE-003", label: "Mid-Senior (FN)", department: "U-FN-008" },
  { value: "U-FN-ROLE-004", label: "Junior (HR)", department: "U-FN-008" },

  // Human Resources
  { value: "U-HR-ROLE-001", label: "Executive (HR)", department: "U-HR-009" },
  { value: "U-HR-ROLE-002", label: "Senior (HR)", department: "U-HR-009" },
  { value: "U-HR-ROLE-003", label: "Mid-Senior (HR)", department: "U-HR-009" },
  { value: "U-HR-ROLE-004", label: "Junior (HR)", department: "U-HR-009" },
];

export const gradeMapByRole = {
  Executive: ["G10", "G9"],
  Senior: ["G8", "G7"],
  "Mid-Senior": ["G6", "G5"],
  Junior: ["G4", "G3"],
  Entry: ["G2", "G1"],
  // For roles like "Executive (MG)", "Senior (SB)", etc.
  "Executive (PT)": ["G10", "G9"],
  "Executive (MG)": ["G10", "G9"],
  "Executive (SB)": ["G10", "G9"],
  "Executive (CS)": ["G10", "G9"],
  "Executive (OP)": ["G10", "G9"],
  "Executive (DA)": ["G10", "G9"],
  "Executive (LC)": ["G10", "G9"],
  "Executive (FN)": ["G10", "G9"],
  "Executive (HR)": ["G10", "G9"],
  "Senior (PT)": ["G8", "G7"],
  "Senior (MG)": ["G8", "G7"],
  "Senior (SB)": ["G8", "G7"],
  "Senior (CS)": ["G8", "G7"],
  "Senior (OP)": ["G8", "G7"],
  "Senior (DA)": ["G8", "G7"],
  "Senior (LC)": ["G8", "G7"],
  "Senior (FN)": ["G8", "G7"],
  "Senior (HR)": ["G8", "G7"],
  "Mid-Senior (PT)": ["G6", "G5"],
  "Mid-Senior (MG)": ["G6", "G5"],
  "Mid-Senior (SB)": ["G6", "G5"],
  "Mid-Senior (CS)": ["G6", "G5"],
  "Mid-Senior (OP)": ["G6", "G5"],
  "Mid-Senior (DA)": ["G6", "G5"],
  "Mid-Senior (LC)": ["G6", "G5"],
  "Mid-Senior (FN)": ["G6", "G5"],
  "Mid-Senior (HR)": ["G6", "G5"],
  "Junior (PT)": ["G4", "G3"],
  "Junior (MG)": ["G4", "G3"],
  "Junior (SB)": ["G4", "G3"],
  "Junior (CS)": ["G4", "G3"],
  "Junior (OP)": ["G4", "G3"],
  "Junior (DA)": ["G4", "G3"],
  "Junior (LC)": ["G4", "G3"],
  "Junior (FN)": ["G4", "G3"],
  "Junior (HR)": ["G4", "G3"],
  "Entry (PT)": ["G2", "G1"],
  "Entry (MG)": ["G2", "G1"],
  "Entry (SB)": ["G2", "G1"],
  "Entry (CS)": ["G2", "G1"],
  "Entry (OP)": ["G2", "G1"],
  "Entry (DA)": ["G2", "G1"],
  "Entry (LC)": ["G2", "G1"],
  "Entry (FN)": ["G2", "G1"],
  "Entry (HR)": ["G2", "G1"],
};
